import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardHeader, Col, Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchWebCities } from '../../actions/web-cities';
import DataTable from '../../components/data-table';

const COLUMNS = [
  { id: 'id', label: 'ID', link: true },
  { id: 'name_en', label: 'English Name', link: true },
  { id: 'name_fr', label: 'French Name' },
  { id: 'name_ar', label: 'Arabic Name' },
  { id: 'webCountry.name_en', label: 'Web Country', sortable: false },
  { id: 'timezone', label: 'IANA Timezone' },
  { id: 'latitude', label: 'Latitude' },
  { id: 'longitude', label: 'Longitude' },
  { id: 'priority', label: 'Priority' },
  { id: 'enabled', label: 'Enabled' },
];

const WebCities = (props) => {
  const { getWebCities } = props;
  return (
    <div className="animated fadeIn">
      <Row>
        <Col xl={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col lg={4}>Web Cities</Col>
                <Col lg={8} style={{ textAlign: 'right' }}>
                  <Button href="/#/web-cities/new" color="success" size="sm">New</Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <DataTable
                resource="webCities"
                urlSchema="web-cities"
                dataSource={getWebCities}
                columns={COLUMNS}
                {...props}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

WebCities.propTypes = {
  getWebCities: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  webCities: PropTypes.arrayOf(PropTypes.object),
};

WebCities.defaultProps = { webCities: [] };

const mapStateToProps = ({ webCities }) => ({
  loading: webCities.loading,
  webCities: webCities.items,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getWebCities: sort => fetchWebCities(sort),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WebCities);
